import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';

@Component({
  selector: 'fx-timeframe',
  templateUrl: './timeframe.component.html',
  styleUrls: ['./timeframe.component.sass'],
})
export class TimeframeComponent implements OnInit {
  @Input() selectedTimeframe: string;
  @Input() tfs = ['month', 'week', 'day'];
  @Output() timeframeChanged = new EventEmitter();
  constructor() {}

  ngOnInit(): void {}

  selectTimeframe(tf: string) {
    this.selectedTimeframe = tf;
    this.timeframeChanged.emit(tf);
  }
}
